import { z } from 'zod';
/** Mayor versión representable: la columna `version` es `integer` (docs/migration/08 §2). */
export const MAX_RESOURCE_VERSION = 2_147_483_647;
/** Versión de un recurso editable: entero positivo. */
export const ResourceVersionSchema = z.int().min(1).max(MAX_RESOURCE_VERSION);
const RESERVED_UUIDS = new Set(['00000000-0000-0000-0000-000000000000', 'ffffffff-ffff-ffff-ffff-ffffffffffff']);
/**
 * `Idempotency-Key`: UUID en forma canónica con guiones (RFC 9562), sin llaves, prefijos ni
 * espacios. Se normaliza a minúsculas, porque la comparación de UUID no distingue mayúsculas.
 * El UUID nulo y el máximo se rechazan: no identifican una operación concreta.
 */
export const IdempotencyKeySchema = z
    .string()
    .regex(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/)
    .transform((value) => value.toLowerCase())
    .refine((value) => !RESERVED_UUIDS.has(value), { message: 'reserved_uuid' });
/** Etiqueta de entidad fuerte con la versión: `"<entero positivo>"`, comillas incluidas. */
const quotedVersion = z
    .string()
    .regex(/^"[1-9][0-9]{0,9}"$/)
    .refine((value) => Number(value.slice(1, -1)) <= MAX_RESOURCE_VERSION, { message: 'version_out_of_range' });
/**
 * Cabecera `If-Match` con formato exacto `"<versión>"` (docs/migration/09 §5).
 * No admite etiquetas débiles (`W/"1"`), `*`, listas, ceros a la izquierda ni espacios.
 * La salida es la versión numérica.
 */
export const IfMatchSchema = quotedVersion.transform((value) => Number(value.slice(1, -1)));
/** Cabecera `ETag` de un recurso editable: `"<versión>"`, el mismo formato que admite `If-Match`. */
export const ETagSchema = quotedVersion;
//# sourceMappingURL=concurrency.js.map